import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "../../css/ListScores.css";

import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

const DisplayHarvestChart = ({ key, heading, survey, surveyIndex, chartOptions }) => {
	const { t } = useTranslation();

	useEffect(() => {
		Highcharts.setOptions({
			colors: [ '#058DC7',  '#DB7093', '#b3d4ff', '#b366ff', '#F5DEB3', '#1a53ff', '#00bfa0', '#dc0ab4', 
			 '#7c1158', '#4421af', '#5d6d7e', '#FFC0CB', '#4d0000','#24CBE5',  '#e9c3ef','#80dfff',
			'#0bb4ff',  '#9b19f5', '#9e6f00',   '#2bc2c2', '#ff6696',
		    '#96a527', '#024b7a',  '#b2b0ea']
		});
	}, []);

	return (
		<div key={key}>
			<div className="row">
				<div className="col">
					<h5 style={{ marginLeft: "2vw", textAlign: 'center' }}><b><span style={{ marginRight: "30px", fontSize: "20px" }}></span>{heading}</b></h5>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
					<h6 style={{ marginLeft: "2vw", float: 'left' }}><b>{'  ' + t("page.locationcompany") + ': '}</b>{survey.locationCompanyName}</h6>
				</div>
				<div className="col-sm-6">
					{(surveyIndex == 0) && (
						<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.eval.level") + ' '}</b></h6>
					)}
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
					<h6 style={{ marginLeft: "2vw", float: 'left' }}><b>{'  ' + t("page.location") + ': '}</b>{survey.locationName}</h6>
				</div>
				<div className="col-sm-6">
					{(surveyIndex == 0) && (
						<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.ready") + ' '}</b><span className="badge result-pass-sm"> </span></h6>
					)}
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
					<h6 style={{ marginLeft: "2vw", float: 'left' }}><b>{'  ' + t("page.product") + ': '}</b>{survey.productNames}</h6>
				</div>
				<div className="col-sm-6">
					{(surveyIndex == 0) && (
						<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.inspect") + ' '}</b><span className="badge result-medium-sm"> </span></h6>
					)}
				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
					<h6 style={{ marginLeft: "2vw", float: 'left' }}><span style={{ marginRight: "30px" }}><b>{'  ' + t("page.harvestDate") + ': '}</b>{survey.harvestDate}</span> </h6>
				</div>
				<div className="col-sm-6">
					{(surveyIndex == 0) && (
						<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.pause") + ' '}</b><span className="badge result-fail-sm"> </span></h6>
					)}

				</div>
			</div>
			<div className="row">
				<div className="col-sm-6">
					<h6 style={{ marginLeft: "2vw", float: 'left' }}><b><span style={{ marginRight: "30px" }}>{t("page.eval")}</span></b>{'  '}<span className={(survey.scoreResult ? ((survey.scoreResult === "L") ? "badge result-pass" : ((survey.scoreResult === "M") ? "badge result-medium" : ((survey.scoreResult === "H") ? "badge result-fail" : ""))) : "")}> </span> </h6>
				</div>
				<div className="col-sm-6">
					{(surveyIndex == 0) && (
						<h6 style={{ marginRight: "2vw", float: 'right' }}><b>{'  ' + t("page.incomplete") + ' '}</b><span className="badge result-incomplete-sm"> </span></h6>
					)}
				</div>

			</div>
			<div className="row" id="reportContainer" style={{ marginTop: "2vh" }}>
				<div className="col">
					<HighchartsReact key={surveyIndex} highcharts={Highcharts} containerProps={{ style: { height: "15vh", minHeight: "10vh", maxHeight: "20vh", overfow: "visible" } }}
						options={chartOptions[survey.answerId]}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<div className="placeholder-pg"></div>
				</div>
			</div>
		</div>
	)
}

export default DisplayHarvestChart;